module.exports = __webpack_public_path__ + "img/c.ed29956b.jpg";